import httpRequest from 'httpRequest'
import { TableLayoutContract } from 'models'

const TABLE_LAYOUT_PREFIX = '/location/table-layout'

const tableLayoutService = {
    getTableLayouts() {
        return httpRequest.get<TableLayoutContract[]>(TABLE_LAYOUT_PREFIX)
    },
    getTableLayout(id: string) {
        return httpRequest.get<TableLayoutContract>(
            `${TABLE_LAYOUT_PREFIX}/${id}`,
        )
    },
    createTableLayout(payload: TableLayoutContract) {
        return httpRequest.post<void>(TABLE_LAYOUT_PREFIX, payload)
    },
    updateTableLayout(id: string, payload: TableLayoutContract) {
        return httpRequest.put<void>(`${TABLE_LAYOUT_PREFIX}/${id}`, payload)
    },
    removeTableLayouts(tableLayoutIDs: string[]) {
        return httpRequest.delete(TABLE_LAYOUT_PREFIX, {
            params: { tableLayoutIDs },
        })
    },
}

export default tableLayoutService
